import { Capacitor } from "@capacitor/core";
import axios from "axios";
const platform = Capacitor.getPlatform();
export const GetRequest = async ({ url, setState, errorMessage }) => {
  try {
    if (setState) {
      setState(true);
    }
    const Authorization = "Bearer " + localStorage.getItem("user-token");

    const { data } = await axios.get(platform == "web" ? url : `https://backend-new.billzpay.com.ng${url}`, {
      headers: {
        Authorization,
      },
    });

    if (!data.err && !(data.message && data.message == "Unauthenticated")) {
      return { data, err: null };
    } else {
      return { data: null, err: data.err?.[0] || "Unauthenticated" };
    }
  } catch (error) {
    console.log(error);
    if (error.response && error.response.data && error.response.data.err && Array.isArray(error.response.data.err) && error.response.data.err && Array.isArray(error.response.data.err)) {
      return { data: null, err: error.response.data.err[0] };
    } else {
      return { data: null, err: errorMessage || "An error occurred try again" };
    }
  } finally {
    if (setState) {
      setState(false);
    }
  }
};

export const PostRequest = async ({ url, setState, body, errorMessage }) => {
  try {
    if (setState) {
      setState(true);
    }
    const Authorization = "Bearer " + localStorage.getItem("user-token");

    const { data } = await axios.post(platform == "web" ? url : `https://backend-new.billzpay.com.ng${url}`, body, {
      headers: {
        Authorization,
      },
    });

    if (!data.err && !(data.message && data.message == "Unauthenticated")) {
      return { data, err: null };
    } else {
      return { data: null, err: data.err?.[0] || "Unauthenticated" };
    }
  } catch (error) {
    console.log(error);
    if (error.response && error.response.data && error.response.data.err && Array.isArray(error.response.data.err) && error.response.data.err && Array.isArray(error.response.data.err)) {
      return { data: null, err: error.response.data.err[0] };
    } else {
      return { data: null, err: errorMessage || "An error occurred try again" };
    }
  } finally {
    if (setState) {
      setState(false);
    }
  }
};

export const PatchJSON = async ({ url, setState, errorMessage, body }) => {
  try {
    if (setState) {
      setState(true);
    }
    const Authorization = "Bearer " + localStorage.getItem("user-token");

    const { data } = await axios.patch(platform == "web" ? url : `https://backend-new.billzpay.com.ng${url}`, body, {
      headers: {
        Authorization,
      },
    });

    if (!data.err && !(data.message && data.message == "Unauthenticated")) {
      return { data, err: null };
    } else {
      return { data: null, err: data.err?.[0] || "Unauthenticated" };
    }
  } catch (error) {
    console.log(error);
    if (error.response && error.response.data && error.response.data.err && Array.isArray(error.response.data.err) && error.response.data.err && Array.isArray(error.response.data.err)) {
      return { data: null, err: error.response.data.err[0] };
    } else {
      return { data: null, err: errorMessage || "An error occurred try again" };
    }
  } finally {
    if (setState) {
      setState(false);
    }
  }
};

export const PatchAppend = async ({ url, setState, errorMessage, body }) => {
  try {
    if (setState) {
      setState(true);
    }
    const Authorization = "Bearer " + localStorage.getItem("user-token");
    body.append("_method", "PATCH");

    const { data } = await axios.post(platform == "web" ? url : `https://backend-new.billzpay.com.ng${url}`, body, {
      headers: {
        Authorization,
      },
    });

    if (!data.err && !(data.message && data.message == "Unauthenticated")) {
      return { data, err: null };
    } else {
      return { data: null, err: data.err?.[0] || "Unauthenticated" };
    }
  } catch (error) {
    console.log(error);
    if (error.response && error.response.data && error.response.data.err && Array.isArray(error.response.data.err) && error.response.data.err && Array.isArray(error.response.data.err)) {
      return { data: null, err: error.response.data.err[0] };
    } else {
      return { data: null, err: errorMessage || "An error occurred try again" };
    }
  } finally {
    if (setState) {
      setState(false);
    }
  }
};

export const DeleteRequest = async ({ url, setState, errorMessage }) => {
  try {
    if (setState) {
      setState(true);
    }
    const Authorization = "Bearer " + localStorage.getItem("user-token");

    const { data } = await axios.delete(platform == "web" ? url : `https://backend-new.billzpay.com.ng${url}`, {
      headers: {
        Authorization,
      },
    });

    if (!data.err && !(data.message && data.message == "Unauthenticated")) {
      return { data, err: null };
    } else {
      return { data: null, err: data.err?.[0] || "Unauthenticated" };
    }
  } catch (error) {
    console.log(error);
    if (error.response && error.response.data && error.response.data.err && Array.isArray(error.response.data.err) && error.response.data.err && Array.isArray(error.response.data.err)) {
      return { data: null, err: error.response.data.err[0] };
    } else {
      return { data: null, err: errorMessage || "An error occurred try again" };
    }
  } finally {
    if (setState) {
      setState(false);
    }
  }
};